import { render, staticRenderFns } from "./PublicAttached.vue?vue&type=template&id=c646500a&scoped=true&"
import script from "./PublicAttached.vue?vue&type=script&lang=js&"
export * from "./PublicAttached.vue?vue&type=script&lang=js&"
import style0 from "./PublicAttached.vue?vue&type=style&index=0&id=c646500a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c646500a",
  null
  
)

export default component.exports